'use client';

import { useMicrocopy } from '@contexts/MicrocopyContext';
import { AtomicCategoryFacet } from '@coveo/atomic-react';
import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';

const categoryFacetStyles = `
@media (min-width: 1024px) {
  atomic-category-facet::part(facet) {
    border: none;
    padding: 0;
  }

  atomic-category-facet::part(label-button) {
    font-size: var(--atomic-text-base);
    font-style: normal;
    font-weight: var(--atomic-custom-font-semibold);
    letter-spacing: var(--atomic-custom-tracking-wide);
    text-transform: uppercase;
  }

  atomic-category-facet[is-refine-modal]::part(value-link) {
    padding-left: 0;
  }

  atomic-category-facet[is-refine-modal]::part(label-button){
    padding-left: 0;
    pointer-events: auto;
  }
}

atomic-category-facet[is-refine-modal] {
  padding-top: var(--atomic-custom-spacing-2);
}

atomic-category-facet[is-refine-modal]::part(label-button-icon) {
  display: block;
}

atomic-category-facet::part(all-categories-button),
atomic-category-facet::part(leaf-value),
atomic-category-facet::part(node-value),
atomic-category-facet::part(value-link),
atomic-category-facet::part(show-more),
atomic-category-facet::part(show-less),
atomic-category-facet::part(parent-button)
 {
  font-size: var(--atomic-text-lg);
  text-transform: capitalize;
}

atomic-category-facet::part(value-link):focus-visible {
  outline: 2px solid var(--atomic-custom-grey-700);
  outline-offset: 2px;
  position: relative;
  z-index: 1;
}

atomic-category-facet::part(active-parent) {
 padding-left: 2rem;
}

atomic-category-facet::part(parents) atomic-category-facet::part(values) {
  padding-left: 2.5rem;
}

atomic-category-facet::part(value-label) {
  color: var(--atomic-custom-grey-800);
}
atomic-category-facet::part(value-count) {
  color: var(--atomic-custom-grey-600);
}
`;

export const AtomicCategoryFacetSection = () => {
  const { searchLabelsMicrocopy } = useMicrocopy<{
    searchLabelsMicrocopy: MicrocopyFragment[];
  }>();
  const categoriesMicrocopy = searchLabelsMicrocopy.find(
    (microcopyFragment) => microcopyFragment.key === 'search.categories'
  );

  return (
    <div className="mt-4 lg:mt-1">
      <style>{categoryFacetStyles}</style>
      <AtomicCategoryFacet
        label={categoriesMicrocopy?.value ?? 'Categories'}
        field="ec_category"
        isCollapsed={false}
        numberOfValues={10}
        delimitingCharacter=" > "
      />
    </div>
  );
};
